import script from "./RegisterIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__